<template>
  <div>
    <AdminCandidate
      v-if="!show_job_form"
    >
      <div
        class="row px-3"
      >
        <div class="col-lg-12 col-xs-12 pt-3 container">
          <div
            class="invitation-tag-div"
          >
            <div
              class="row"
              style="height: 30vh"
            >
              <div
                class="col-lg-12 col-xs-12 pt-3 container d-flex"
              >
                <div
                  class="center d-flex"
                  style="margin-right: auto; margin-left: auto;"
                >
                  <img
                    src="/images/Jovool_logo.png"
                    style="width: 150px; align-self: end"
                  />
                </div>
              </div>
              <div class="col-lg-12 col-xs-12 pt-3 container d-flex">
                <h5
                  style="align-self: end"
                >
                  Bem-vindo! Para acessar o processo seletivo preencha o código de acesso.
                </h5>
              </div>
            </div>
            <div
              class="row"
            >
              <div class="col-lg-12 col-xs-12 pt-3 container">
                <input
                  class="form-control width100 bg-input-candidate"
                  style="text-align: center; border: none; height: 40px; align-self: end"
                  type="text"
                  v-model="invitation_tag"
                  placeholder="Código de acesso*"
                />
              </div>
            </div>
            <div
              class="row"
            >
              <div class="col-lg-12 col-xs-12">
                <button
                  type="button"
                  :disabled="load"
                  @click="showJobForm"
                  class="btn full width100 normal-degrade btn-degrade btn-login-candidate mt-3"
                >
                  <i class="fa fa-check"></i>
                  Cadastrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminCandidate>
    <div
      v-if="show_job_form"
    >
      <JobShow
        :job="job"
        :job_questions="job_questions"
        :job_link="job_link"
        :candidate_id="candidate_id"
        :candidate_uid="candidate_uid"
        :applies="applies"
        :index="index"
        :url="url"
        :videos="videos"
        :account_uid="account_uid"
        :bigfive="bigfive"
        :recruiting_company="recruiting_company"
        :extra_checkboxes="extra_checkboxes"
        @tag_error="tagError"
      />
    </div>
  </div>
</template>

<script>
import AdminCandidate from "layouts/AdminCandidate.vue";
import JobShow from "./Show.vue";

export default {
  components: {
    AdminCandidate,
    JobShow
  },

  props: [
    "job",
    "job_questions",
    "job_link",
    "candidate_id",
    "candidate_uid",
    "applies",
    "index",
    "url",
    "videos",
    "account_uid",
    "bigfive",
    "recruiting_company",
    "extra_checkboxes"
  ],

  data() {
    return {
      invitation_tag: "",
      load: false,
      show_job_form: false,
    }
  },

  methods: {
    showJobForm() {
      this.load = true;
      axios.get(
        `/tags/${this.account_uid}?name=${this.invitation_tag}`
      )
      .then((response) => {
        if (response.data.tags) {
          this.show_job_form = true;
        } else {
          this.$toast.error("Código de acesso inválido.");
          this.load = false;
        }
      });
    },

    tagError(){
      this.$toast.error("Sessão expirada! Tente novamente.");
      this.show_job_form = false;
    }
  }
}
</script>

<style scoped>
.invitation-tag-div {
  max-width: 700px;
  height: 40vh;
  margin-left: auto;
  margin-right: auto;
}
</style>
